export default {
    STORE_SEEKER_FIELDS(state, data) {
        state.seeker_fields = data;
    },
};
